import { BaseLog, BaseLogArgs } from './BaseLog';
import { LEVEL } from './LEVEL';

export function StreamLog({ message, data = {}, stacktrace, level = LEVEL.WARN }: Partial<BaseLogArgs>) {
    return BaseLog({
        category: 'STREAM',
        message,
        data,
        level,
        stacktrace
    });
}
